// extracted by mini-css-extract-plugin
export var danger = "_3h-6";
export var lightPink = "_3h-a";
export var medium = "_3h-j";
export var nearSquare = "_3h-m";
export var neutralBlue = "_3h-8";
export var neutralYellow = "_3h-7";
export var noCapitalize = "_3h-1";
export var normal = "_3h-2";
export var pill = "_3h-0";
export var primary = "_3h-3";
export var primaryLight = "_3h-4";
export var shadow = "_3h-n";
export var small = "_3h-k";
export var solidBlack = "_3h-i";
export var solidGreen = "_3h-d";
export var solidLightBlue = "_3h-f";
export var solidNavy = "_3h-e";
export var solidOrange = "_3h-h";
export var solidPink = "_3h-g";
export var solidRed = "_3h-b";
export var solidWhite = "_3h-9";
export var solidYellow = "_3h-c";
export var success = "_3h-5";
export var xsmall = "_3h-l";